import { useCallback } from 'react';

import { useLazyQuery } from '@apollo/client';

import courseraOpenBadgesExperiments from 'bundles/epic/clients/courseraOpenBadges';
import BadgeSource from 'bundles/s12n-common/api/BadgeSource.graphql';
import type { BadgeSourceQuery, BadgeSourceQueryVariables } from 'bundles/s12n-common/api/__generated__/BadgeSource';

const useFetchIsCourseraBadge = () => {
  const [query] = useLazyQuery<BadgeSourceQuery, BadgeSourceQueryVariables>(BadgeSource, {
    context: { clientName: 'gatewayGql' },
  });

  const isCourseraBadgeEnabled = !!courseraOpenBadgesExperiments.get('courseraBadgeEnabled');

  return useCallback<(badgeTemplateId: string) => Promise<boolean>>(
    async (badgeTemplateId) => {
      if (!isCourseraBadgeEnabled) return false;
      const { data } = await query({
        variables: {
          badgeTemplateId,
        },
      });
      if (data?.Badge?.queryBadgeTemplateById.badgeSource === 'COURSERA') return true;
      return false;
    },
    [query, isCourseraBadgeEnabled]
  );
};

export { useFetchIsCourseraBadge };
